import { useEffect } from 'react'
import { AddressVerificationHeader } from '../header'
import { Outlet, useLocation } from 'react-router-dom'
import { getProjectByToken } from './api'
/**
 * AddressVerifictionLayout
 * Layout component for address verification flow, fetches project logo and renders header and outlet.
 */
export const AddressVerifictionLayout = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('request')

    useEffect(() => {
        if (token) {
            getProjectByToken({ request_token: token }).then((d) => {
                localStorage.setItem('logo_url', d?.data)
            })
        }
    }, [token])

    return (

        <div className="d-flex  justify-content-center align-items-center">

            <div className="bg-white d-flex flex-column gap-2 w-800px px-4 py-4 vh-100">

                <AddressVerificationHeader />
                <Outlet />
            </div>
        </div>
    )
}
